// extracted by mini-css-extract-plugin
module.exports =  {"root":"TlGKSJGtrcZ9uDXDqsut","link":"yuBxanlbGfCseag8xON8"};